import axios from 'axios'

axios.defaults.withCredentials = true
const api = 'https://cms.lit.bgpu.ru'
// const api = `http://192.168.202.115:8083`;
// const api = `http://192.168.251.2:8086`;
// const api = 'http://192.168.202.101:8080';

const baseURL = `${api}/public`

const API = axios.create({
  baseURL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Access-Control-Allow-Origin': '*',
    Accept: 'application/json',
    'Access-Control-Allow-Methods': 'GET,POST,PUT,DELETE,OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With'
    // 'Content-Type': 'multipart/form-data'

  }
})

export default {

  getStaticbyRoute (route) {
    return API.get(`get/${route}`)
  }

}
